import type { IAmenClickStats } from "@dc-ireland/shared"
import { IconCalendar, IconCalendarMonth, IconCalendarWeek, IconHandClick } from "@tabler/icons-react"

type Props = {
  stats: IAmenClickStats
  title?: string
}

const metrics = [
  {
    key: "total" as const,
    label: "All time",
    icon: IconHandClick,
    featured: true,
  },
  {
    key: "today" as const,
    label: "Today",
    icon: IconCalendar,
    featured: false,
  },
  {
    key: "last7Days" as const,
    label: "Last 7 days",
    icon: IconCalendarWeek,
    featured: false,
  },
  {
    key: "last30Days" as const,
    label: "Last 30 days",
    icon: IconCalendarMonth,
    featured: false,
  },
]

const formatCount = (value: number) => value.toLocaleString()

const AmenClickStats = ({ stats, title = "Amen analytics" }: Props) => (
  <section className="overflow-hidden rounded-2xl border border-[#e2e8f0] bg-white">
    <div className="flex items-center justify-between gap-3 border-b border-[#eef1f6] px-5 py-3.5">
      <div>
        <p className="font-dm-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-[#9e7e43]">
          Weekly declaration
        </p>
        <h2 className="mt-0.5 font-outfit text-base font-semibold tracking-tight text-[#1f1f1f]">
          {title}
        </h2>
      </div>
    </div>

    <div className="grid grid-cols-2 divide-x divide-y divide-[#eef1f6] lg:grid-cols-4 lg:divide-y-0">
      {metrics.map(({ key, label, icon: Icon, featured }) => (
        <div
          key={key}
          className={`relative flex flex-col gap-3 px-5 py-5 ${
            featured ? "bg-gradient-to-br from-[#00205c]/[0.04] to-transparent" : "bg-white"
          }`}
        >
          {featured && (
            <span className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-[#00205c] to-[#9e7e43]" />
          )}

          <div className="flex items-center justify-between gap-2">
            <span className="font-dm-sans text-[11px] font-medium uppercase tracking-[0.12em] text-[#787878]">
              {label}
            </span>
            <span
              className={`flex size-7 items-center justify-center rounded-lg ${
                featured
                  ? "bg-[#00205c]/10 text-[#00205c]"
                  : "bg-[#f4f6fb] text-[#787878]"
              }`}
            >
              <Icon size={14} stroke={1.5} />
            </span>
          </div>

          <p
            className={`font-outfit text-3xl font-semibold tracking-tight tabular-nums md:text-[2rem] ${
              featured ? "text-[#00205c]" : "text-[#1f1f1f]"
            }`}
          >
            {formatCount(stats[key])}
          </p>
        </div>
      ))}
    </div>
  </section>
)

export default AmenClickStats
